// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"332":"instructions","641":"minasidor"}[chunkId] + "." + {"332":"ea4a2ee2","641":"faa5992c"}[chunkId] + ".css";
};